import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectState, usePopoverHandlers, Select, Popover, PopoverType, PopoverPosition, } from '@as/cotopaxi';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { mapSizeSelectOptions } from '../../util/ProductUtil';
import { SizeDropdown } from '../size-dropdown/SizeDropdown';
export const ProductTileSizeSelect = ({ colorId, productId, dropdownProps, selectedSku, sizes, isOneSizeProduct, scrollableWrapperSelector, onSizeChange, hasError, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const [selectState, setSelectState] = useState(null);
    const sizeSelectRef = useRef(null);
    const { filteredSizes, options: selectOptions } = mapSizeSelectOptions(sizes, true);
    const handleSelectedItemChange = (option) => {
        setSelectState(null);
        onSizeChange(String(option.value));
    };
    useEffect(() => {
        if (hasError) {
            handlePopoverOpen(null, sizeSelectRef.current);
            setSelectState(SelectState.ERROR);
        }
        else {
            handlePopoverClose();
            setSelectState(null);
        }
    }, [hasError]);
    useEffect(() => {
        if (selectState === SelectState.ERROR && selectedSku) {
            setSelectState(null);
            handlePopoverClose();
        }
    }, [selectedSku]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { flex: { grow: 1 }, children: _jsx(SizeDropdown, { id: `product_tile_size_select_${productId}_${colorId}`, toggleElementRef: sizeSelectRef, handleSelectedItemChange: handleSelectedItemChange, appendToBody: dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.appendToBody, sizes: filteredSizes, options: selectOptions, selectedSku: selectedSku, toggleElement: _jsx(Select, { name: `size-select-${productId}-${colorId}`, options: selectOptions, selectedValue: selectedSku, placeholder: t(isOneSizeProduct ? 'product.extensiveBlock.singleSizeAvailable' : 'pdp.size.choose.default'), defaultOptionValue: selectOptions.length === 1 && !isOneSizeProduct ? selectOptions[0].value : undefined, state: selectState, dataQA: "size-select", disabled: true, noChevron: isOneSizeProduct, fullWidth: true, height: "sm" }) }) }), _jsx(Popover, { type: PopoverType.TOOLTIP, anchorEl: anchorEl, onClose: handlePopoverClose, position: PopoverPosition.BOTTOM, stickyWrapper: Boolean(scrollableWrapperSelector), scrollableWrapperEl: scrollableWrapperSelector && typeof window === 'object'
                    ? document.querySelector(scrollableWrapperSelector)
                    : undefined, children: _jsx(TextAlpha, { variant: "bodyS", as: "span", children: t('pdp.size.choose.default') }) })] }));
};
